import { useState } from 'react'
import PersonalInfoFormModal from './PersonalInfoFormModal'
import ProposalSuccessModal from './ProposalSuccessModal'

interface PanModalProps {
  onBack: () => void
}

type PanStep = 'personalInfoForm' | 'success'

export interface ProposalData {
  authorizationLink: string
  linkExpirationDate: string
}

export default function PanModal({ onBack }: PanModalProps) {
  const [step, setStep] = useState<PanStep>('personalInfoForm')
  const [proposalData, setProposalData] = useState<ProposalData>({
    authorizationLink: '',
    linkExpirationDate: '',
  })

  switch (step) {
    case 'personalInfoForm':
      return (
        <PersonalInfoFormModal
          onBack={onBack}
          onContinue={() => setStep('success')}
          onSaveProposalData={setProposalData}
        />
      )
    case 'success':
      return <ProposalSuccessModal proposalData={proposalData} />
    default:
      return null
  }
}
